import ContainerCenter from './components/containers/center/cointainer'
import ContainerLeft from './components/containers/left/container'
import ContainerRight from './components/containers/right/container'
import Layout from './components/layout/layout'
import GlobalStyle from './style-global'



function App() {
  return (
    <div className="App">
      <GlobalStyle/>
      <Layout>
        <ContainerLeft/>
        <ContainerCenter/>
        <ContainerRight/>
      </Layout>
    </div>
  );
}

export default App;
